import React from 'react'
import Image from "../assets/mockup.png"
import { useTranslation } from 'react-i18next'

const HomepageWhyUs = () => {
    const { t } = useTranslation();

    return (
        <div className='homepage-why-us-content'>
            <div className="container">
                <h3 className='text-center'>{t('Güvenilir Stratejilerle Geleceğinize Yatırım Yapın')}</h3>
                <div className="row align-items-end mt-5">
                    <div className="col-lg-3">
                        <div className="why-us-card-item">
                            <div className="icon-card">
                                <img width="36" height="36" src="https://img.icons8.com/ios-filled/50/low-priority.png" alt="low-priority" />
                            </div>
                            <h5 className='mt-4'>{t('Düşük Spread Oranları')}</h5>
                            <p className="mb-0">
                                {t('Paragon, yatırımcılarına düşük spread oranları sunarak, işlem maliyetlerini minimize eder ve daha kârlı fırsatlar yaratır.')}
                            </p>
                        </div>
                        <div className="why-us-card-item mt-5">
                            <div className="icon-card">
                                <img width="50" height="50" src="https://img.icons8.com/ios-filled/50/cheap-2.png" alt="cheap-2" />
                            </div>
                            <h5 className='mt-4'>{t('Yüksek Likidite')}</h5>
                            <p className="mb-0">
                                {t('Global piyasalarda yüksek likidite ile hızlı ve sorunsuz işlem yapabilmenizi sağlar, yatırım fırsatlarını değerlendirmek kolaylaşır.')}
                            </p>
                        </div>
                        <div className="why-us-card-item my-5">
                            <div className="icon-card">
                                <img width="36" height="36" src="https://img.icons8.com/ios-filled/50/multiple-devices.png" alt="multiple-devices" />
                            </div>
                            <h5 className='mt-4'>{t('Güvenli İşlem Platformu')}</h5>
                            <p className="mb-0">
                                {t('Paragon Yatırım, en son güvenlik protokolleri ile donatılmış, kullanıcı dostu ve güvenli işlem platformları sunar.')}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-6 text-center">
                        <img src={Image} alt="" width="65%" style={{ transform: "rotate(-1.5deg)" }} />
                    </div>
                    <div className="col-lg-3">
                        <div className="why-us-card-item text-end mt-lg-0 mt-5">
                            <div className="d-flex justify-content-end">
                                <div className="icon-card">
                                    <img width="42" height="42" src="https://img.icons8.com/ios-filled/50/headset.png" alt="headset" />
                                </div>
                            </div>
                            <h5 className='mt-4'>{t('7/24 Müşteri Desteği')}</h5>
                            <p className="mb-0">
                                {t('Her zaman yanınızda olan profesyonel müşteri destek ekibi, her türlü soru ve işlem konusunda hızlı ve etkili çözüm sunar.')}
                            </p>
                        </div>
                        <div className="why-us-card-item text-end mt-5">
                            <div className="d-flex justify-content-end">
                                <div className="icon-card">
                                    <img width="46" height="46" src="https://img.icons8.com/ios-filled/50/financial-analytics.png" alt="financial-analytics" />
                                </div>
                            </div>
                            <h5 className='mt-4'>{t('Profesyonel Piyasa Analizleri')}</h5>
                            <p className="mb-0">
                                {t('Yatırımcılarınıza, piyasa hareketlerini daha iyi analiz edebilmesi için kapsamlı ve güncel analiz raporları sunar.')}
                            </p>
                        </div>
                        <div className="why-us-card-item text-end my-5">
                            <div className="d-flex justify-content-end">
                                <div className="icon-card">
                                    <img width="50" height="50" src="https://img.icons8.com/glyph-neue/64/education.png" alt="education" />
                                </div>
                            </div>
                            <h5 className='mt-4'>{t('Eğitim ve Seminerler')}</h5>
                            <p className="mb-0">
                                {t('Yatırımcıların bilgilerini artırmak ve stratejik kararlar alabilmek için ücretsiz eğitim materyalleri ve seminerler düzenler.')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomepageWhyUs